module.exports = __webpack_public_path__ + "static/media/slugcar.92ae4951.png";